import {
  CustomAttributeMetadataInterface,
  CustomAttributeOptionInterface,
} from '~/composables';

export const getCustomAttributeOptions = (
  customAttributeMetadata: CustomAttributeMetadataInterface[],
  attributeCode: string,
): CustomAttributeOptionInterface[] => {
  const attribute = customAttributeMetadata?.find(
    (item) => item.code === attributeCode,
  );
  return (attribute?.options || []) as CustomAttributeOptionInterface[];
};
